import { ApiClient } from "../../utils/api-client";

export const sendQuery = query => {
    return ApiClient.post('/contact', query, {});
}